const StatusComponent = ({ status }) => {
    let spanStyle;
    switch (status) {
        case 'Completed':
            spanStyle = (
                <span
                    className="appkiticon icon-circle-checkmark-outline"
                    style={{ color: 'green', fontSize: '1.3rem', marginLeft: '1rem' }}
                />
            );
            break;
        case 'Error':
            spanStyle = (
                <span
                    className="appkiticon icon-close-outline"
                    style={{ color: '#E0301E', fontSize: '1.3rem', marginLeft: '1rem' }}
                />
            );
            break;
        case 'Failed':
            spanStyle = (
                <span
                    className="appkiticon icon-circle-delete-outline"
                    style={{ color: '#E0301E', fontSize: '1.3rem', marginLeft: '1rem' }}
                />
            );
            break;
        default:
            spanStyle = '';
            break;
    }
    return spanStyle;
};

export default StatusComponent;
